import React from "react";
import CashTransactionsView from "./view";

const CashTransactions = () => {
  return <CashTransactionsView />;
};

export default CashTransactions;
